<template>
  <div class="ShowNoticeContent">
    <p
      v-if="content.headline"
      class="notice_headline"
    >
      {{ content.headline }}
    </p>
    <p
      v-if="content.subtitle"
      class="notice_subtitle"
    >
      {{ content.subtitle }}
    </p>
    <ul :class="['notice_paragraphs', `notice_deep_${deepIndex}`]">
      <li
        v-for="(paragraph, index) in content.paragraphs"
        :key="index"
        class="notice_paragraph"
      >
        <span v-if="typeof paragraph === 'string'">{{ paragraph }}</span>
        <ShowNoticeContent
          v-else
          :content="paragraph"
          :deepIndex="deepIndex + 1"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ShowNoticeContent',
  props: {
    content: {
      type: [Object, String],
      default: '',
    },
    deepIndex: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang='scss' scroped>
  .ShowNoticeContent {
    margin-bottom: 15px;
  }
  ul {
    margin-bottom: 0;
  }
  .notice_paragraph {
    list-style-position: outside;
  }
  .notice_deep_0 {
    list-style-type: decimal;
    & > .ShowNoticeContent {
      margin-bottom: 15px;
    }
  }
  .notice_deep_1 {
    list-style-type: lower-alpha;
  }
  .notice_deep_2 {
    list-style-type: lower-roman;
  }
  .notice_deep_3 {
    list-style-type: disc;
  }
</style>
